// src/colors/colorPalettes.js
import basicPalettes from './basicPalettes';
import monochromaticPalettes from './monochromaticPalettes';
import contrastingPalettes from './contrastingPalettes';
import naturalPalettes from './naturalPalettes';
import gradientPalettes from './gradientPalettes';
import vintagePalettes from './vintagePalettes';
import neonPalettes from './neonPalettes';
import pastelPalettes from './pastelPalettes';

const colorPalettes = {
  basic: { name: "Basic Colors", palettes: basicPalettes },
  monochromatic: { name: "Monochromatic", palettes: monochromaticPalettes },
  contrasting: { name: "Contrasting", palettes: contrastingPalettes },
  natural: { name: "Natural", palettes: naturalPalettes },
  gradient: { name: "Gradient Inspired", palettes: gradientPalettes },
  vintage: { name: "Vintage", palettes: vintagePalettes },
  neon: { name: "Neon", palettes: neonPalettes },
  pastel: { name: "Pastel", palettes: pastelPalettes },
};

export { colorPalettes };
export default colorPalettes;
